<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>


        <div class="row mt-5">
            <div class="col-12 ml-2 mr-2">

                <div class="KSpinner" v-if="isInitiating">                    
                    <div class="spinner-border text-info"></div>
                    <h2 class="LoadingText">Loading....</h2>
                </div>

                <div class=".continer" v-else>
                    <div class="iHScrollable"> 
            
                        <v-data-table :headers="_headers" :items="data" class="elevation-1" :search="search">

                        <template v-slot:top>
                            <v-toolbar flat >
                                <v-col cols="3"></v-col>
                                <v-col cols="6" class="d-flex justify-space-around"> <v-toolbar-title class="iscreentitle">Clients</v-toolbar-title>  </v-col>
                                <v-col cols="3"></v-col>                                    
                            </v-toolbar>
                            <v-text-field v-model="search" label="Search" class="mx-4"></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="viewItem(item.id)"><font-awesome-icon icon="eye" size="sm"/></button>
                            <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="editItem(item.id)"><font-awesome-icon icon="edit" size="sm"/></button>
                            <button  class="btn btn-info m-0 mr-1 p-0 pl-1 pr-1" type="button" @click="deleteItem(item.id)"  v-if="isUserLoggedIn && isUserAdmin"><font-awesome-icon icon="trash" size="sm"/></button>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                            {{ formatDateTime(item.createdAt) }}
                        </template>
                        <template v-slot:item.modifiedAt="{ item }">
                            {{ formatDateTime(item.modifiedAt) }}
                        </template>

                        </v-data-table>

                    
                    </div>
                </div>
            </div>
            <v-snackbar v-model="showSnackbar" >
                {{ snackBarText }}
                <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
            </v-snackbar>           
            <Footer class="footerStickedToBottom" ></Footer>        
        
        </div>    
    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import {DB} from '../firebase/db';
import Utils from '../utils/util';

export default {   
    name: 'VesselList',  
    data() {
        return {

            data:[],
            

            isLoading:false,
            isInitiating:false,

            showSnackbar:false,
            snackBarText:'',
            snackbarColor:'green',

            search:'',
        }
    },
    components: {          
        NavBar,         
        Footer,        
    },
    props:{
        propData:null,
    },
    created() {
        if(this.$route.params == undefined || this.$route.params.propData == undefined){
            this.fetchAll();
        }else{
            this.data = this.$route.params.propData;
        }
        
    },
    methods: {  
        async fetchAll(){
            this.isInitiating = true;
            this.data = [];
            var _this = this;
            DB.collection("clients").
                orderBy("modifiedAt", "desc").
                get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { 
                        _this.data.push(doc.data());
                    });
                    _this.data.sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1: 0)
                    _this.isInitiating = false;
                })
                .catch((error) => {
                    _this.showError("Failed to fetch records. Error: ", error)
                    this.data = [];
                    _this.isInitiating = false;
                });
        },
        viewItem(id){
            var route = '/view-client?id=' + id  + '&mode=view'          
            this.$router.push(route);
        },
        editItem(id){
            var route = '/edit-client?id=' + id  + '&mode=edit'          
            this.$router.push(route);
        },
        deleteItem(id){
            if(confirm('Do you really want to delete the record?')){
                DB.collection('clients').doc(id).delete().then(() => {
                    this.showMsg("Client Deleted successfully!");
                    this.fetchAll();
                }).catch((error) => {
                    this.showError("Failed to delete Client. Error: ", error)
                });
            }
        },
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        formatDateTime(input){
            return Utils.formatDateTime(input);
        }

    },
    computed: {
        isUserLoggedIn(){
            return this.$store.state.user? true:false;
        },
        isUserAdmin(){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Admin'){
                    return true;
                }
            }
            return false;
        },
        _headers(){
            let headers = [                
                { text: 'Actions', align: 'start', sortable: false, value: 'actions', show: true},  
                { text: 'Name', align: 'start', sortable: true, value: 'name', show: true},                    
                { text: 'Abbreviation', align: 'start', sortable: true, value: 'abbreviation', show: true},          
                { text: 'Address', align: 'start', sortable: true, value: 'address', show: true},          
                { text: 'Contact', align: 'start', sortable: true, value: 'contact', show: true},          
                { text: 'Created By', align: 'start', sortable: true, value: 'createdBy', show: this.isUserAdmin},          
                { text: 'Created At', align: 'start', sortable: true, value: 'createdAt', show: this.isUserAdmin},          
                { text: 'Modified By', align: 'start', sortable: true, value: 'modifiedBy', show: this.isUserAdmin},          
                { text: 'Modified At', align: 'start', sortable: true, value: 'modifiedAt', show: this.isUserAdmin},           
            ];
            return headers.filter(x => x.show)
        }
    }, 
    
}


</script>



<style lang="scss">

</style>
